module.exports = __webpack_public_path__ + "3afbcce52b3960e7da61b050ddaef7df.svg";